module.exports = __webpack_public_path__ + "static/rapido_company-4aa6231c44f7878956451b722b9f6e14.svg";